import OurProjectsModal from './OurProjectsModal';

export default OurProjectsModal;
